import { Store } from '../core/assets'

export default new Store({
  photo: 'https://i.esdrop.com/d/f/w3LVwhrrgU/NSJbPV8BJI.jpg',
  name: 'Geumyeop Yoon',
  email: 'yoongy3333@gmail.com',
  github: 'https://github.com/DevYBecca'
})
